import { type NavigateFunction } from "react-router-dom";
import HttpError from "src/api/HttpError";
import { getPinnedLocations, postPinnedLocations } from "src/api/pinned.api";
import { UserAppRole } from "src/constants/userRoles.enum";
import type PinnedLocation from "src/types/PinnedLocation";

export async function updateUserPinnedLocations(pinnedLocations: PinnedLocation[]): Promise<PinnedLocation[]> {
  try {
    const updatedLocations = await postPinnedLocations(pinnedLocations);
    return updatedLocations;
  } catch (error: unknown) {
    const err = error as HttpError;
    throw new Error(err.errors[0]);
  }
}

export async function getUserPinnedLocations(
  pinned: PinnedLocation[],
  setAppPinned: (pinned: PinnedLocation[]) => void
): Promise<PinnedLocation[]> {
  let pinnedLocations;
  try {
    pinnedLocations = await getPinnedLocations();
  } catch {
    throw new Error("Error while fetching user pinned locations");
  }

  if (pinnedLocations) {
    await setUserPinnedLocations(pinnedLocations, setAppPinned);
  } else {
    const newUserPinnedLocations = pinned;
    await postPinnedLocations(newUserPinnedLocations);
    pinnedLocations = newUserPinnedLocations;
  }

  return pinnedLocations;
}

async function setUserPinnedLocations(pinnedLocations: PinnedLocation[], setAppPinned: (pinned: PinnedLocation[]) => void): Promise<void> {
  if (pinnedLocations) {
    setAppPinned(pinnedLocations);
  }
}

export async function handleNavigation(userRoles: string[], navigate: NavigateFunction): Promise<void> {
  if (userRoles.includes(UserAppRole.MallViewer)) {
    navigate("/center-region-dashboard");
  }

  if (!userRoles.includes(UserAppRole.MallViewer) && userRoles.includes(UserAppRole.ShopViewer)) {
    navigate("/shop-region-dashboard");
  }

  if (
    !userRoles.includes(UserAppRole.MallViewer) &&
    !userRoles.includes(UserAppRole.ShopViewer) &&
    userRoles.includes(UserAppRole.StationViewer)
  ) {
    navigate("/station-region-dashboard");
  }

  if (
    !userRoles.includes(UserAppRole.MallViewer) &&
    !userRoles.includes(UserAppRole.ShopViewer) &&
    !userRoles.includes(UserAppRole.StationViewer) &&
    userRoles.includes(UserAppRole.InsightViewer)
  ) {
    navigate("/extended-analytics");
  }

  if (
    !userRoles.includes(UserAppRole.MallViewer) &&
    !userRoles.includes(UserAppRole.ShopViewer) &&
    !userRoles.includes(UserAppRole.StationViewer) &&
    !userRoles.includes(UserAppRole.InsightViewer) &&
    userRoles.includes(UserAppRole.DocumentViewer)
  ) {
    navigate("/files");
  }
}
